import { Routes } from '@angular/router';
import { provideQuizStore } from '@app/store/quiz';
import { provideQuizQuestionsStore } from '@app/store/quiz-questions';
import { provideQuizQuestionStore } from '@app/store/quiz-question';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const quizzesModalRoutes: Routes = [
    {
        path: 'quizzes/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'quizzes/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizStore(), ...provideQuizQuestionStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'quizzes/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizStore(), ...provideQuizQuestionsStore(), ...provideQuizQuestionStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
